<p-dialog [(visible)]="visible"
          [dismissableMask]="true"
          [modal]="true"
          [ngClass]="dialogClass"
          [resizable]="false"
          class="app-dialog"
          closeIcon="close-icon">

  <p-header>
    <div class="header-parent">
      <div class="app-dialog-header-parent">
        <ng-content select="[app-dialog-header]"></ng-content>
      </div>
      <div (click)="visible = false" class="close-button"></div>
    </div>
  </p-header>

  <div class="content">
    <ng-content select="[app-dialog-content]"></ng-content>
  </div>

  <p-footer class="app-dialog-footer">
    <ng-content select="[app-dialog-footer]"></ng-content>
  </p-footer>
</p-dialog>
